import React from 'react';
import PropTypes from 'prop-types';
import {
  Drawer,
  Box,
  Typography,
  Stack,
  IconButton,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  Divider,
  FormGroup,
  FormLabel
} from '@mui/material';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import Iconify from './Iconify';

SimpleCalendarFilter.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  recurrenceFilters: PropTypes.object.isRequired,
  onRecurrenceFilterChange: PropTypes.func.isRequired,
  statusFilters: PropTypes.object.isRequired,
  onStatusFilterChange: PropTypes.func.isRequired,
  onResetFilter: PropTypes.func.isRequired
};

export default function SimpleCalendarFilter({
  open,
  onClose,
  recurrenceFilters,
  onRecurrenceFilterChange,
  statusFilters,
  onStatusFilterChange,
  onResetFilter
}) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: 300 }
      }}
    >
      <Box sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Typography variant="h6">Filtros Avançados</Typography>
          <IconButton onClick={onClose} size="small">
            ×
          </IconButton>
        </Stack>

        <Divider sx={{ mb: 2 }} />

        {/* Recurrence Filters */}
        <FormLabel component="legend" sx={{ mb: 1, fontSize: '0.875rem', fontWeight: 600 }}>
          Recorrência do Evento
        </FormLabel>
        <FormGroup sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={recurrenceFilters.ONCE}
                onChange={(e) => onRecurrenceFilterChange('ONCE', e.target.checked)}
                size="small"
              />
            }
            label="Evento Único"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={recurrenceFilters.WEEKLY}
                onChange={(e) => onRecurrenceFilterChange('WEEKLY', e.target.checked)}
                size="small"
              />
            }
            label="Semanal"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={recurrenceFilters.MONTHLY}
                onChange={(e) => onRecurrenceFilterChange('MONTHLY', e.target.checked)}
                size="small"
              />
            }
            label="Mensal"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={recurrenceFilters.ANNUALLY}
                onChange={(e) => onRecurrenceFilterChange('ANNUALLY', e.target.checked)}
                size="small"
              />
            }
            label="Anual"
          />
        </FormGroup>

        <Divider sx={{ mb: 2 }} />

        {/* Status Filters */}
        <FormLabel component="legend" sx={{ mb: 1, fontSize: '0.875rem', fontWeight: 600 }}>
          Status do Evento
        </FormLabel>
        <FormGroup sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={statusFilters.active}
                onChange={(e) => onStatusFilterChange('active', e.target.checked)}
                size="small"
              />
            }
            label="Ativo"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={statusFilters.finished}
                onChange={(e) => onStatusFilterChange('finished', e.target.checked)}
                size="small"
              />
            }
            label="Finalizado"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={statusFilters.canceled}
                onChange={(e) => onStatusFilterChange('canceled', e.target.checked)}
                size="small"
              />
            }
            label="Cancelado"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={statusFilters.rescheduled}
                onChange={(e) => onStatusFilterChange('rescheduled', e.target.checked)}
                size="small"
              />
            }
            label="Remarcado"
          />
        </FormGroup>

        <Divider sx={{ mb: 2 }} />

        {/* Actions */}
        <Stack spacing={1}>
          <Button
            variant="outlined"
            color="error"
            onClick={onResetFilter}
            fullWidth
            startIcon="🗑️"
          >
            Limpar Filtros
          </Button>
          <Button
            variant="contained"
            onClick={onClose}
            fullWidth
          >
            Aplicar
          </Button>
        </Stack>
      </Box>
    </Drawer>
  );
}